import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BwgButton from '../../atoms/Button';

const imagem =
  'https://storage.googleapis.com/static-files-4fdd9378-835d-40e4-b124-36699ae5cc08/coop/apontamento_producao/undraw_notify.svg';

const WrapperTelaSemParametrizacao = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 32px;
`;

const LeftImage = styled.img`
  max-width: 270px;
  margin-right: 50px;
`;

const RightContent = styled.div`
  max-width: 540px;
`;

function TelaSemParametrizacao({ onCriarParamClick }) {
  return (
    <WrapperTelaSemParametrizacao>
      <LeftImage src={imagem} />
      <RightContent>
        <h2>Nenhuma Parametrização Cadastrada</h2>
        <p>
          É necessário ter uma parametrização para prosseguir com o apontamento de produção. Por favor, cadastre uma
          nova parametrização.
        </p>
        <BwgButton
          type="primary"
          onClick={onCriarParamClick}
        >
          Cadastrar parametrização
        </BwgButton>
      </RightContent>
    </WrapperTelaSemParametrizacao>
  );
}

TelaSemParametrizacao.propTypes = {
  onCriarParamClick: PropTypes.func.isRequired,
};

export default TelaSemParametrizacao;
